import { Comodidade } from "./Comodidades";

export enum TipoImovel {
  Casa = 'Casa',
  Apartamento = 'Apartamento',
  Terreno = 'Terreno',
  SalaComercial = 'Sala Comercial',
  Galpao = 'Galpão',
  Rural = 'Rural',
}

export enum StatusImovel {
  Disponivel = 'Disponível',
  Alugado = 'Alugado',
  Vendido = 'Vendido',
  Inativo = 'Inativo',
}

export enum TipoAnuncio {
  Venda = 'Venda',
  Aluguel = 'Aluguel',
}

export interface FotosImovel {
    id?: number;
    url?: string;
    descricao?: string;
    destaque?: boolean;
}

export interface Imovel {
  id?: number;
  codigoReferencia?: string;
  
  titulo: string;
  descricao: string;
  
  tipo: TipoImovel;
  status: StatusImovel;
  tipoAnuncio: TipoAnuncio;
  
  // Localização
  cep: string;
  logradouro: string;
  numero?: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string; // 2 caracteres

  // Características
  areaUtil: number; // m²
  areaTotal: number; // m²
  quartos: number;
  suites: number;
  banheiros: number;
  vagasGaragem: number;
  anoConstrucao?: number;
  
  // Valores
  valor: number;
  Condominio?: number;
  Iptu?: number;

  // Outros
  comodidades: Comodidade[];
  fotos?: FotosImovel[];
  
  // Relacionamentos
  proprietarioId: number;
  corretorId?: number;
  
  destaque: boolean; // Para destacar na página inicial, por exemplo
}